import { render, staticRenderFns } from "./ManageClaimsProvider.vue?vue&type=template&id=44008a03&scoped=true&"
import script from "./ManageClaimsProvider.vue?vue&type=script&lang=js&"
export * from "./ManageClaimsProvider.vue?vue&type=script&lang=js&"
import style0 from "./ManageClaimsProvider.vue?vue&type=style&index=0&id=44008a03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44008a03",
  null
  
)

export default component.exports